// @flow

import styled from 'styled-components'
import theme from 'styled-theming'
import hexToRgba from 'hex-to-rgba'

import { myTheme } from '../../../styles'

const {
  color, space, fontWeight, fontSize,
} = myTheme

const dividerColor = theme('mode', {
  light: hexToRgba(color.darkBlueGray, 0.1),
  dark: hexToRgba(color.white, 0.1),
})
const postTitleColor = theme('mode', {
  light: color.silver,
  dark: color.darkSilver,
})
const PostTitle = styled.h4`
  border-bottom: 0.0625rem solid ${dividerColor};
  padding-bottom: ${space.one};
  font-weight: ${fontWeight.six};
  text-transform: uppercase;
  font-size: ${fontSize.eight};
  color: ${postTitleColor};
`

export default PostTitle



// WEBPACK FOOTER //
// ./src/scenes/feed/post-title/post-title.js